<template lang="html">
    <div class="previewYGDLR-page">
        <Slogan theTitle="原告代理人"/>
        <template v-if="ygdlr && ygdlr.length">
            <van-cell-group class="ygdlr-box" v-for="(item, index) in this.ygdlr"
                            :key="index">
                <span class="ssyg-test"  @click="toastJointCcxx(cBqSqrmc(item.cBqSqrid))">{{cBqSqrmc(item.cBqSqrid)}}</span>
                <van-field
                    readonly
                    clearable
                    label="所属原告"
                ></van-field>
                <van-field
                    v-model="item.cDlrlx"
                    readonly
                    clearable
                    label="代理人类型"
                    @click="toastJointCcxx(dlrLx)"
                ></van-field>
                <van-field
                    v-model="item.cDlrxm"
                    readonly
                    label="代理人姓名"
                ></van-field>
                <van-field
                    v-model="item.cDlrxb"
                    readonly
                    label="性别"
                ></van-field>
                <van-field
                    v-model="item.cDlrzjlx"
                    readonly
                    label="证件类型"
                    @click="toastJointCcxx(item.cDlrzjlx)"
                ></van-field>
                <van-field
                    v-model="item.cDlrzjh"
                    readonly
                    label="证件号码"
                    @click="toastJointCcxx(item.cDlrzjh)"
                ></van-field>
                <van-field
                    v-model="item.cPhone"
                    readonly
                    label="手机号码"
                ></van-field>
                <van-field
                    v-if="item.cDlrlx1 == 1"
                    v-model="item.cDlrzjhm"
                    readonly
                    label="执业证件号码"
                    @click="toastJointCcxx(item.cDlrzjhm)"
                ></van-field>
                <van-field
                    v-if="item.cDlrlx1 == 1"
                    v-model="item.cDlrszls"
                    readonly
                    label="代理人所在律所"
                    @click="toastJointCcxx(item.cDlrszls)"
                ></van-field>
                <van-field
                    v-model="item.cGddh"
                    readonly
                    label="固定电话"
                ></van-field>
            </van-cell-group>
        </template>
<!--        暂无数据的提示 -->
        <p v-else class="fd-empty-tips">暂无数据</p>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    import { Toast } from 'vant';
    import {typeXb, typeDlrlx, typeSfzjlx} from '../../../filters/index'

    export default {
        components: {
            Slogan
        },
        data() {
            return {
                ygdlr: [],
                dlrLx: "",
                dlrLx2: "",
                dlrLx3: "",
                dlrLx4: "",
                dlrLx5: "",
                dlrSex: "",
                zjlx: "",
                ssyg:"",
                checkoutYG:""
            }
        },
        computed:{
            cBqSqrmc() {
                return function (value) {
                    let name = []
                    let sqrlist = window.sessionStorage.getItem("sqrDBlist")
                    let sqr = JSON.parse(sqrlist)
                    sqr.map((item) => {
                        if (value.indexOf(item.cId) > -1) {
                            name.push(item.cSqrlx == 1 ? item.cSqrxm : item.cQymc)
                        }
                    })
                    return name.join(',')
                }
            },
        },
        methods: {
        //     async getList(){
        //        await this.getYgdlrList()
        //        await this.getSQRlist()
        //    },
          toastJointCcxx(value){
                Toast(value);
            },
            getYgdlrList() {
                let Id = window.sessionStorage.getItem("dbid")
                this.$axios.get('ssbq/api/ssdb/ygdlrsxq' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {
                    // this.ygdlr = res.data
                    //代码值特殊处理
                    res.data && res.data.map(item => {
                        // if(item.cGddh == '--'){
                        //     item.cGddh = ''
                        // }
                        // if(item.cDlrlx == 1){
                        //      this.dlrLx = typeDlrlx(item.cDlrlx)
                        // }else if(item.cDlrlx == 2){
                        //      this.dlrLx2 = typeDlrlx(item.cDlrlx)
                        // }else if(item.cDlrlx == 3){
                        //      this.dlrLx3 = typeDlrlx(item.cDlrlx)
                        // }else if(item.cDlrlx == 4){
                        //      this.dlrLx4 = typeDlrlx(item.cDlrlx)
                        // }else if(item.cDlrlx == 5){
                        //      this.dlrLx5 = typeDlrlx(item.cDlrlx)
                        // }
                        // this.dlrSex = typeXb(item.cDlrxb)
                        // this.zjlx = typeSfzjlx(item.cDlrzjlx)
                        let temp = {
                            cBqSqrid:item.cBqSqrid,
                            cBqDlrid:item.cBqDlrid,
                            cBqId:item.cBqId,
                            cDlrlx:typeDlrlx(item.cDlrlx),
                            cDlrlx1:item.cDlrlx,
                            cDlrszls:item.cDlrszls,
                            cDlrxb:typeXb(item.cDlrxb),
                            cDlrxm:item.cDlrxm,
                            cDlrzjh:item.cDlrzjh,
                            cDlrzjhm:item.cDlrzjhm,
                            cDlrzjlx:typeSfzjlx(item.cDlrzjlx),
                            cGddh:item.cGddh,
                            cPhone:item.cPhone,
                            dtDsrbirthday:item.dtDsrbirthday
                        }
                        this.ygdlr.push(temp)
                    })
                })
            },
            getSQRlist(){
                let Id = window.sessionStorage.getItem("dbid")
                this.$axios.get('ssbq/api/ssdb/sqrsxq' + "?time=" + new Date().getTime() + "&dbid=" + Id).then(res => {
                    this.sqrlist = res.data
                    // window.sessionStorage.setItem("sqrDBlist",JSON.stringify(this.sqrlist))
                })
            }
        },
        mounted() {
            this.getYgdlrList()
            // this.getSQRlist()
        },
        created() {

        }
    }
</script>

<style lang="less" scoped>
    .ssyg-test{
        position: absolute;
        right: 20px;
        top: 15px;
        color: #333 !important;
        z-index: 99;
        width:210px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display:inline-block;
        text-align:right;
    }
</style>
